import React from 'react';

import AppRoute from '@/initializers/src/pages';
import SWWRoute from '@/initializers/src/pages/SWW';
import ErrorElement from '@/lib/errorLogger/ErrorElement';

const routes = [
  {
    id: 'ROOT_LAYOUT',
    element: <AppRoute />,
    errorElement: <ErrorElement />,
    children: [
      {
        id: 'SWW',
        path: '*',
        element: <SWWRoute />,
      },
    ],
  },
];

export default routes;
